<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div class="titlePage mb-3">Prorrogação de boletos</div>
      </b-col>
    </b-row>
    <b-col cols="12">
      <fccTable
        striped
        hover
        :optionsButton="options"
        :fields="fieldsAtualiza"
        :orderby="sortBy"
        :items="lstResultado"
        :actions="actionsOutrasFases"
        responsive
        :porPage="itemPorPage"
        titlePage="Prorrogação de boletos"
        titlePDF="Prorrogação de boletos"
      />
    </b-col>
    <fcc-modal
      centered
      id-modal="listarCandidatos"
      title-modal="Listar Candidatos"
      esconde-footer
      trava-esc
      size="xl"
      trava-back
    >
      <fccTable
        striped
        hover
        modal
        :fields="fieldsCandidato"
        :orderby="sortBy"
        :items="lstCandidatos"
        :actions="actionsCandidatos"
        responsive
        pdf
        csv
        xls
        search
        pagination
        :porPage="itemPorPage"
        titlePage="Candidatos"
        titlePDF="Prorrogação de boletos"
      />
    </fcc-modal>
    <fcc-modal
      centered
      id-modal="prorroga"
      title-modal="Prorroga Boleto"
      esconde-footer
      trava-esc
      @close="solicitaProrrogacao == null"
      trava-back
    >
      <template v-if="solicitaProrrogacao">
        <b-form @submit.prevent="salvarSolicita" autocomplete="off">
          <div class="row mt-3">
            <div class="col-6">
              <fcc-date-input
                class="form-control"
                required
                type="date"
                v-model="solicitaProrrogacao.data"
                >Data Prorrogação</fcc-date-input
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-5">
              <span
                ><toggle-button v-model="solicitaProrrogacao.fila" :sync="true" disabled /> Enviar
                para fila</span
              >
            </div>
            <div class="col-sm-6">
              <span
                ><toggle-button v-model="solicitaProrrogacao.teste" :sync="true" /> Apenas usuários
                de testes</span
              >
            </div>
          </div>
          <div class="row text-right mt-3">
            <div class="col"><fcc-button type="submit">Salvar</fcc-button></div>
          </div>
        </b-form>
      </template>
    </fcc-modal>
    <fcc-modal
      centered
      id-modal="viewClientes"
      title-modal="Visualizar Candidato"
      esconde-footer
      trava-esc
      trava-back
    >
      <template v-if="candidatoSelecionado != null">
        <div>{{ candidatoSelecionado.TituloFila }}</div>

        <div><strong>ID:</strong> {{ candidatoSelecionado.idFilaRabbit }}</div>
        <div><strong>Candidato:</strong> {{ candidatoSelecionado.JsonFila.NOME_CANDIDATO }}</div>
        <div><strong>CPF:</strong> {{ candidatoSelecionado.JsonFila.CPF_CANDIDATO }}</div>
        <div><strong>Número Pedido:</strong> {{ candidatoSelecionado.num_pedido }}</div>
        <div><strong>Número Documento:</strong> {{ candidatoSelecionado.numero_documento }}</div>
        <div><strong>Data inicio:</strong> {{ candidatoSelecionado.dtInsert }}</div>
        <div><strong>Data Manutenção:</strong> {{ candidatoSelecionado.dtManut }}</div>
        <div><strong>Processado:</strong> {{ candidatoSelecionado.Fila ? 'Sim' : 'Não' }}</div>
        <div><strong>Pago:</strong> {{ candidatoSelecionado.Pago ? 'Sim' : 'Não' }}</div>
        <div><strong>Erro:</strong> {{ candidatoSelecionado.error ? 'Sim' : 'Não' }}</div>
        <div>
          <strong>Retorno: </strong>
          {{ candidatoSelecionado.retorno }}
        </div>
        <div>
          <strong>Dados enviados: </strong>
          {{ candidatoSelecionado.JsonFila }}
        </div>
      </template>
    </fcc-modal>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      baseUrlNode: '',
      lstResultado: [],
      lstCandidatos: [],
      candidatoSelecionado: null,
      solicitaProrrogacao: null,
      sortBy: 'datainicio',
      itemPorPage: '100',
      fieldsAtualiza: [
        { key: 'IdAtualiza', label: 'ID Atualiza', sortable: true },
        {
          key: 'ImportacaoCandidatos',
          label: 'Importação',
          sortable: true,
          formatter(data) {
            return data ? 'Sim' : 'Não'
          }
        },
        {
          key: 'AtualizacaoCandidatos',
          label: 'Atualização',
          sortable: true,
          formatter(data) {
            return data ? 'Sim' : 'Não'
          }
        },
        {
          key: 'StatusImportacao',
          label: 'Status',
          formatter(data) {
            return data ? 'Sim' : 'Não'
          }
        },
        { key: 'dtInsert', label: 'Data Inicio', type: 'datahora' },
        { key: 'dtManut', label: 'Data Manutenção', type: 'datahora' },
        { key: 'dtFinalCandidatos', label: 'Data Final', type: 'datahora' },
        { key: 'actions', label: '' }
      ],
      fieldsCandidato: [
        { key: 'idFilaRabbit', label: 'ID', sortable: true },
        { key: 'TituloFila', label: 'Título', sortable: true },
        { key: 'num_pedido', label: 'Número Pedido', sortable: true },
        {
          key: 'error',
          label: 'Erro',
          formatter(data) {
            return data ? 'Sim' : 'Não'
          }
        },
        {
          key: 'Pago',
          label: 'Pago',
          formatter(data) {
            return data ? 'Sim' : 'Não'
          }
        },
        {
          key: 'Fila',
          label: 'Processado',
          formatter(data) {
            return data ? 'Sim' : 'Não'
          }
        },
        { key: 'dtInsert', label: 'Data Inicio', type: 'datahora' },
        { key: 'dtManut', label: 'Data Manutenção', type: 'datahora' },
        { key: 'actions', label: '' }
      ],
      actionsCandidatos: [
        {
          button: true,
          funcaoButton: 'viewClientes',
          icon: 'eye',
          tooltip: 'Visualizar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      options: [
        {
          funcaoButton: 'prorrogaBoleto',
          text: 'Prorrogar Boletos',
          tooltip: 'Prorrogar Boletos',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ],

      actionsOutrasFases: [
        {
          button: true,
          funcaoButton: 'viewFase',
          icon: 'eye',
          tooltip: 'Visualizar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ]
    }
  },
  components: {},
  methods: {
    salvarSolicita() {
      this.callConfirm('Atenção', 'Deseja prorrogar os boletos?').then((result) => {
        if (result.value) {
          this.carregaTexto('Prorrogar Boleto')
          const data = this.$moment(this.solicitaProrrogacao.data, 'YYYY-MM-DDTHH:mm:ss').format(
            'YYYY-MM-DD'
          )
          axios
            .get(
              this.baseUrlNode +
                `candidatos?data=${data}&spi=${this.solicitaProrrogacao.spi}&nome=${this.solicitaProrrogacao.nome}&fila=${this.solicitaProrrogacao.fila}&teste=${this.solicitaProrrogacao.teste}`,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarSolicitacoes()
            })
            .catch((error) => {
              this.callAlert(
                'Atenção',
                Array.isArray(error.response.data)
                  ? error.response.data[0]?.error
                  : error.response.data.error || 'Erro desconhecido',
                'error',
                'error'
              )
            })
            .finally(() => {
              this.carregaTexto()
              this.$root.$emit('bv::hide::modal', 'prorroga')
            })
        }
      })
    },
    prorrogaBoleto() {
      this.solicitaProrrogacao = {
        data: this.$moment(this.controlePage.boletohorario, 'YYYY-MM-DDTHH:mm:ss').format(
          'DD/MM/YYYY HH:mm:ss'
        ),
        spi: this.controlePage.spi,
        fila: false,
        teste: false,
        nome: this.dadosUserSession.usuNome
      }
      this.$root.$emit('bv::show::modal', 'prorroga')
    },
    viewClientes(_, idCliente) {
      this.candidatoSelecionado = { ...idCliente }
      this.candidatoSelecionado.JsonFila = JSON.parse(this.candidatoSelecionado.JsonFila)
      this.$root.$emit('bv::show::modal', 'viewClientes')
    },
    viewFase(_, IdAtualiza) {
      axios
        .get(
          this.baseUrlNode + 'candidatos-por-idatualiza?idatualiza=' + IdAtualiza.IdAtualiza,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstCandidatos = response.data
          this.$root.$emit('bv::show::modal', 'listarCandidatos')
        })
        .catch(this.setErrorSystem)
    },
    listarSolicitacoes() {
      this.carregaTexto('Carregando')
      axios
        .get(
          this.baseUrlNode + 'resultado-processamento-boletos?spi=' + this.controlePage.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstResultado = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  props: {
    controlePage: Object
  },
  mounted() {
    this.baseUrlNode = store.state.baseUrlNode
    this.listarSolicitacoes()
  }
}
</script>